export default "__VITE_ASSET__1fb1fd06__"